import { Link } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import { TiStarFullOutline, TiStarHalfOutline } from "react-icons/ti";
import paneImg from "../../assets/images/profile.jpg";

const MapBox = ({ setCurrentPriceOverlayViewRef }) => {
  const handleClick = () => {
    setCurrentPriceOverlayViewRef(false);
  };
  return (
    <div
      className={`absolute min-w-[350px] bottom-[calc(100%_+_15px)] left-0 text-sm transition-all duration-500 delay-200 z-[10000]`}
    >
      <div className=" cursor-pointer bg-[#fff] w-full p-3 rounded-md relative after:absolute after:content-[''] after:border-8 after:inline-block after:border-transparent after:border-t-[#fff] after:top-full after:left-1/2 after:-translate-x-1/2 -translate-x-[43%] shadow-md">
        <Link to={""}>
          <div className="content flex">
            <div className="image rounded-md overflow-hidden w-7/12 h-full">
              <img src={paneImg} alt="" className="w-full" />
            </div>
            <div className="info p-2 px-3 flex-auto">
              <div className="type-of-service font-medium">
                <p className="uppercase text-[13px] text-[#5f5f5f] ">
                  Nutrition
                </p>
              </div>
              <div className="title">
                <p className="text-[17px] text-black">
                  How to lower cholesterol with your diet
                </p>
              </div>
              <div className="name-status">
                <p>
                  <span className="name">Ebru Bekiroğlu</span>
                  <span> | </span>
                  <span className="status text-green-700">Online</span>
                </p>
              </div>
              <div className="desc">
                <p>30 Min session with Ebru</p>
              </div>
              <div className="rate">
                <div className="stars flex text-xl text-black">
                  <TiStarFullOutline />
                  <TiStarFullOutline />
                  <TiStarFullOutline />
                  <TiStarFullOutline />
                  <TiStarHalfOutline />
                </div>
              </div>
            </div>
            <div className="price">
              <div className="price text-[#e66553] text-base font-medium">
                ₺29
              </div>
            </div>
          </div>
        </Link>
        <div className="close  absolute top-0 left-0 p-3">
          <span
            className="text-black text-sm rounded-md bg-black/25 p-1 inline-block"
            onClick={handleClick}
          >
            <IoMdClose />
          </span>
        </div>
      </div>
    </div>
  );
};

export default MapBox;
